import React, { useEffect } from "react";
import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
} from "reactstrap";
import classnames from "classnames";

export const DeliveryConfigModal = ({
  isOpen,
  toggle,
  pickedConfigurationKey,
  validation,
}) => {
  const handleSubmit = e => {
    e.preventDefault();
    validation.handleSubmit();
    return false;
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle} tag="h4">
        {!!pickedConfigurationKey ? "Edycja klucza konfiguracyjnego" : "Dodaj klucz konfiguracyjny"}
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col xs={12}>
              <Nav tabs className="nav-tabs-custom nav-justified">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: true,
                    })}
                  >
                    <span className="d-block d-sm-none">
                      <i className="fas fa-home"></i>
                    </span>
                    <span className="d-none d-sm-block">Klucz konfiguracyjny</span>
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={"1"} className="p-3 text-muted">
                <TabPane tabId="1">
                  <Row>
                    <Col lg="6 mb-3">
                      <Label className="form-label">Nazwa klucza</Label>
                      <Input
                        name="key"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.key || ""}
                        disabled={!!pickedConfigurationKey}
                        invalid={
                          validation.touched.key &&
                            validation.errors.key
                            ? true
                            : false
                        }
                      />
                      {validation.touched.key &&
                        validation.errors.key ? (
                        <FormFeedback type="invalid">
                          {validation.errors.post_code}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col lg="6 mb-3">
                      <Label className="form-label">
                        Wartość klucza
                      </Label>
                      <Input
                        name="value"
                        type="number"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        step={0.01}
                        value={validation.values.value || 0}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12 mb-3">
                      <Label className="form-label">Opis</Label>
                      <Input
                        name="description"
                        type="text"
                        step={0.01}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.description || ""}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Button type="submit" color="primary">
                      Zapisz
                    </Button>
                  </Row>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal >
  );
};
